"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENVIRONMENT = exports.getEnv = exports.isClient = exports.isServer = void 0;
const useServerState_1 = require("../hooks/useServerState");
/**
 * Determins wether the code should be allowed within the Server Bundle (Node.js)
 * @deprecated Unsure whether this works as intended. Consider using the `process.env.BUILD_TARGET` variable guard yourself.
 * @returns boolean
 */
const isServer = () => {
  if (process.env.BUILD_TARGET === 'server') return true;
  return !(typeof window !== 'undefined' && window.document);
};
exports.isServer = isServer;
/**
 * Determines wether the code should be allowed within the Client Bundle (Browsers)
 * @deprecated Unsure whether this works as intended. Consider using the `process.env.BUILD_TARGET` variable guard yourself.
 * @returns boolean
 */
const isClient = () => !isServer();
exports.isClient = isClient;
var ENVIRONMENT;
(function (ENVIRONMENT) {
  ENVIRONMENT["LOCAL"] = "local";
  ENVIRONMENT["DEV"] = "dev";
  ENVIRONMENT["QA"] = "qa";
  ENVIRONMENT["PROD"] = "prod";
})(ENVIRONMENT || (ENVIRONMENT = {}));
exports.ENVIRONMENT = ENVIRONMENT;
/**
 * Get the current environment.
 * Runs safely on Server and Client, but operates differently.
 * Server pulls from process.env.ENVIRONMENT, which is a kubernetes-set environment variable
 * Client pulls from a static config redux store for the ClientPublic values, which includes env passed from server.
 * @returns ENVIRONMENT (string)
 */
const getEnv = () => {
  var _process, _process$env;
  if ((_process = process) !== null && _process !== void 0 && (_process$env = _process.env) !== null && _process$env !== void 0 && _process$env.ENVIRONMENT) {
    return process.env.ENVIRONMENT;
  }
  const serverState = (0, useServerState_1.getServerState)('config');
  if (serverState !== null && serverState !== void 0 && serverState.env) {
    return serverState === null || serverState === void 0 ? void 0 : serverState.env;
  }
  return ENVIRONMENT.LOCAL;
};
exports.getEnv = getEnv;